function injectStyle (ssrContext) {
  require("!!../../../../../../../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?minimize!../../../../../../../../../node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-974ca23e\",\"scoped\":false,\"hasInlineConfig\":true}!stylus-loader!../../../../../../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Slider.vue")
  require("!!../../../../../../../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?minimize!../../../../../../../../../node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-974ca23e\",\"scoped\":true,\"hasInlineConfig\":true}!stylus-loader!../../../../../../../../../node_modules/vue-loader/lib/selector?type=styles&index=1!./Slider.vue")
}
var Component = require("!../../../../../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!ts-loader!../../../../../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Slider.vue"),
  /* template */
  require("!!../../../../../../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-974ca23e\",\"hasScoped\":true,\"preserveWhitespace\":false}!../../../../../../../../../node_modules/vue-loader/lib/template-compiler/preprocessor?engine=pug!../../../../../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Slider.vue"),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-974ca23e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/pages/profile/components/info/components/block/components/slider/Slider.vue
// module id = 456d0473bb7db0ff4c6a
// module chunks = 89